import firebase from "../../firebase";

export default function({ officeId, rooms }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingAdmin",
        funcName: "addRoomsToOffice",
        data: { officeId, rooms }
    });
}
